import constant from 'lodash/constant';
import omitBy from 'lodash/omitBy';
import moment from 'moment';
import { bool, func, string } from 'prop-types';
import React from 'react';
import { SingleDatePicker } from 'react-dates';

import { INTERNAL_DATE_FORMAT, UI_DATE_FORMAT } from '../../utils/constants';
import getDatasetFromProps from '../../utils/get-dataset-from-props';

const isDayBlocked = constant(false);
const isOutsideRange = constant(false);

const omitDatasetProps = props =>
  omitBy(props, (_, key) => key.startsWith('data-'));

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
  }

  handleFocusChange({ focused }) {
    this.setState({ focused });
  }

  handleChange(date) {
    const { name, onChange } = this.props;

    onChange({
      target: {
        name,
        value: date && date.format(INTERNAL_DATE_FORMAT),
        dataset: getDatasetFromProps(this.props),
      },
    });
  }

  render() {
    const { name, onChange, readOnly, value, ...rest } = this.props;
    const { focused } = this.state;

    return (
      <SingleDatePicker
        displayFormat={UI_DATE_FORMAT}
        date={value && moment(value)}
        disabled={readOnly}
        focused={focused}
        isDayBlocked={isDayBlocked}
        isOutsideRange={isOutsideRange}
        numberOfMonths={1}
        onFocusChange={this.handleFocusChange}
        onDateChange={this.handleChange}
        {...omitDatasetProps(rest)}
      />
    );
  }
}

DatePicker.propTypes = {
  id: string,
  name: string,
  onChange: func,
  readOnly: bool,
  value: string,
};

DatePicker.defaultProps = {
  id: undefined,
  name: undefined,
  onChange: () => {},
  readOnly: undefined,
  value: null,
};

export default DatePicker;
